













        import Vue from 'Vue';
    import Vuex from 'Vuex';
    import Vuetify from 'Vuetify';
    import VueRoute from 'Vue-Router';
    import { ISupportedCulture } from '../../../../../../CommonScripts/Abstractions';
    export default Vue.extend({
        name: 'culture-selector-item',
        props: {
            culture: { type: Object as () => ISupportedCulture, required: true },
        },
        computed: {
            langImageUrl(): string {
                return `${this.$store.state.baseUrl}images/locale/${this.culture.name}`;
            },
            displayName(): string {
                return this.culture.displayName;
            }
        },
        methods: {
            selectCulture(): void {
                this.$emit('click', { culture: this.culture })
            }
        }
    });
